/* tslint:disable */

/**
 */
export class Permission_v2 {
    role_id?: number;
    company_id?: number;
    permission_data?: string;
}
